import { cn } from '@sparklayer-io/spark-dash-ui/lib/styles';

type FloatingSelectOption = { value: string; text: string; disabled?: boolean };

type FloatingSelectProps = {
  name: string;
  label: string;
  required?: boolean;
  options: FloatingSelectOption[];
  value: string;
  onChange: (value: string) => void;
};

export function FloatingSelect({
  name,
  label,
  required,
  options,
  value,
  onChange,
}: FloatingSelectProps) {
  return (
    <div className="relative">
      <select
        id={name}
        name={name}
        value={value}
        required={required}
        disabled={options.length === 0}
        className="peer block w-full cursor-pointer appearance-none rounded-md border border-gray-300 px-3 pt-3 pb-2 text-sm shadow-xs invalid:text-gray-400 focus:border-indigo-500 focus:outline-hidden focus:ring-indigo-500 disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-500"
        onChange={(event) => onChange(event.target.value)}
      >
        {options.map((option) => (
          <option
            key={option.value}
            value={option.value}
            disabled={option.disabled}
            className={option.disabled ? 'text-gray-400' : 'text-gray-700'}
          >
            {option.text}
          </option>
        ))}
      </select>
      <label
        htmlFor={name}
        className={cn(
          'pointer-events-none absolute inset-s-3 z-10 origin-left transform bg-white px-2 text-gray-400 text-sm duration-300 peer-focus:top-2 peer-focus:translate-x-0 peer-focus:-translate-y-4 peer-focus:px-2 peer-focus:text-indigo-600',
          value !== '' ? 'top-2 -translate-y-4' : 'top-2.75 -translate-x-2 scale-100',
        )}
      >
        {label}
      </label>
    </div>
  );
}
